import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles()((theme) => ({
  languageSelection: {
    height: `100vh`,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
  languageSelectionInfo: {
    maxWidth: 400,
    display: "flex",
    flexDirection: "column",
  },
  button: {
    position: "relative",
    marginTop: theme.spacing(2),
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function LanguageSelection({
  t,
  selectedRole,
  languages,
  handleSelectLanguage,
  handlePreviousStep,
  selectedLanguage,
  setSelectedLanguage,
  plan,
}) {
  const [loading, setLoading] = useState(false);
  const { classes } = useStyles();
  const handleSelect = async (language) => {
    try {
      setLoading(true);
      setSelectedLanguage(language);
      await handleSelectLanguage(language);
      // This is the final step so don't move to the next step
      // handleNextStep();
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className={classes.languageSelection}>
        <div className={classes.languageSelectionInfo}>
          <Typography variant='h5' gutterBottom>
            {selectedRole === "learn"
              ? t("i_want_to_learn")
              : t("i_want_to_teach")}
          </Typography>
          {languages.map((key, idx) => (
            <div className={classes.button} key={`languageoption_${idx}`}>
              <Button
                variant='outlined'
                color='primary'
                onClick={() => handleSelect(key)}
                disabled={loading || selectedLanguage}
                fullWidth
              >
                {t(key)}
              </Button>
              {loading && selectedLanguage === key && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          ))}
          <Button
            color='primary'
            onClick={handlePreviousStep}
            className={classes.button}
            disabled={
              loading ||
              plan === "learn" ||
              plan === "teacher_pro" ||
              selectedLanguage
            }
          >
            {t("go_back")}
          </Button>
        </div>
      </div>
    </>
  );
}

export default LanguageSelection;
